(function () {
    'use strict';

    function ReserveServiceItemController($uibModal, $scope, $state, $stateParams, PriceInfoCustom, PriceInfoSearch, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ServiceOptionItem, ServiceOptionItemCustom, PriceInfoDtailCustom, OrderBagServiceItem, ServiceItemCustom, ServiceTimeSessionCustom, SettingInfoCustom, ServiceTimeSession, dateUtil, ScheduleInfoCustom, TimingInfo, OrderBagCustom, Servant, DateUtils) {
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.formState = 'orderbagitem';
        // $ctrl.initMode ='DEFAULT';
        $ctrl.options = null;
        $ctrl.getPriceInfoDtail = getPriceInfoDtail;
        $ctrl.priceInfoDtails = null;
        $ctrl.addOrderBagDtails = addOrderBagDtails;
        $ctrl.computeTotalPrice = computeTotalPrice;
        $ctrl.isSaving = false;
        $ctrl.saveDtail = saveDtail;
        //$ctrl.findFormState = findFormState;
        $ctrl.prev = prev;

        $ctrl.FinalApprove = FinalApprove;
        $ctrl.serviceItem_changed = serviceItem_changed;
        $ctrl.openPersonInfoModal = openPersonInfoModal;
        $ctrl.serviceItems = null;
        $ctrl.qtyChanged = qtyChanged;
        $ctrl.availableDates_changed = availableDates_changed;
        $ctrl.availableTimes_changed = availableTimes_changed;
        $ctrl.servant_changed = servant_changed;
        $ctrl.availableDynamicDates_changed = availableDynamicDates_changed;
        $ctrl.availableDynamicFromTime_changed = availableDynamicFromTime_changed;
        $ctrl.availableDynamicToTime_changed = availableDynamicToTime_changed;

        $ctrl.updateAvailableDates = updateAvailableDates;
        $ctrl.updateAvailableFromTime = updateAvailableFromTime;
        $ctrl.updateAvailableToTime = updateAvailableToTime;
        $ctrl.updateServantList = updateServantList;
        $ctrl.updateServiceList = updateServiceList;

        $ctrl.servantList = [];
        $ctrl.selectedServiceTimeSession = {};
        $ctrl.selectedDynamicDate = null;
        $ctrl.selectedDynamicTime = null;
        $ctrl.allAvailableDynamicTimes = null;
        $ctrl.selectedServant = null;
        $ctrl.timeUnitQty = 1;
        $ctrl.selectedToTime = null;
        $ctrl.showPrices = showPrices;
        if (!$ctrl.editMode)
            $ctrl.editMode = 'NONE'; // 'REPLACE_TIME' , 'EDIT_ORDER_BAG_ITEM'

        // console.log('hasMultipleReserveTime: ' + $ctrl.hasMultipleReserveTime);


        $ctrl.scheduleType = 'PRIMARY';
        $ctrl.floatingTimeType = null;
        $ctrl.availableQty = [];
        $ctrl.maxAvailableQty = 0;
        $ctrl.showCountBox = true;
        $ctrl.selectedService = null;
        $ctrl.selectedServiceDuration = null;


        $ctrl.availableTimeUnitQty = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        $ctrl.timeUnitQty_Changed = timeUnitQty_Changed;


        $ctrl.settingInfo = SettingInfoCustom.getSettingInfoByCurrentCompany().query();
        //test


        loadPage();


        //--------------------
        $ctrl.simulateQuery = false;
        $ctrl.isDisabled = false;

        $ctrl.servicesNames = [];

        $ctrl.querySearch = querySearch;


        //--------------------
        $ctrl.fromDateToLoad = new Date();
        $ctrl.toDateToLoad = DateUtils.addDays(new Date(), 30);
        $ctrl.isDatesLoading = false;
        $ctrl.loadMoreAvailableDates = loadMoreAvailableDates;

//-------------------------------


        function querySearch(query) {
            var temp = [];


            angular.forEach($ctrl.serviceItems, function (item) {
                if (item.itemTitle.indexOf(query) > -1) {
                    temp.push(item);
                } else if (query == null) {
                    temp = $ctrl.serviceItems;
                }
            })

            return temp;

        }


        function loadAllServiceItems() {

            ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function (items) {

                $ctrl.serviceItems = items;
            });
        }

        function loadServiceItemsByServantId() {

            if ($ctrl.defaultServantId) {
                ServiceItemCustom.getServiceItemsByServantId($ctrl.defaultServantId).query(function (items) {
                    $ctrl.serviceItems = items;
                });
            }
        }


//-------------------------------


        function setServant(servantid) {
            $ctrl.orderBagServiceItem.servant = null;
            if (servantid) {
                $ctrl.orderBagServiceItem.servant = {id: servantid}
            }
        }

        function getServantId() {

            if ($ctrl.orderBagServiceItem.servant)
                return $ctrl.orderBagServiceItem.servant.id;
            if ($ctrl.selectedServant)
                return $ctrl.selectedServant.id;

            return null;
        }


        function updateServantList(then) {
            //for now if 'REPLACE_TIME' return
            if ($ctrl.editMode == 'REPLACE_TIME')
                return;

            resetLoadDatesDefault();

            if ($ctrl.initMode == 'CALENDAR_CUSTOM' && $ctrl.defaultServantId) {
                updateServantListWithDefault();
                return;
            }


            setServant();
            $ctrl.servantList = [];
            if ($ctrl.orderBagServiceItem.serviceItemId) {
                ServiceItemCustom.getServiceServants($ctrl.orderBagServiceItem.serviceItemId).query(function (servants) {
                        $ctrl.servantList = servants;

                        if (servants && servants.length > 1) {
                            ServiceItemCustom.getAutoSelectServant($ctrl.orderBagServiceItem.serviceItemId).query(function (selecedServant) {

                                    if (selecedServant && selecedServant.id) {
                                        angular.forEach(servants, function (s) {
                                            if (s.id == selecedServant.id)
                                                setServant(selecedServant.id);
                                        });
                                    } else {
                                        if (servants[0])
                                            setServant(servants[0].id);

                                        if (then)
                                            then();
                                    }
                                    if (then)
                                        then();

                                    $ctrl.updateAvailableDates(then);
                                },
                                function () {
                                    if (servants[0])
                                        setServant(servants[0].id);

                                    if (then)
                                        then();
                                    $ctrl.updateAvailableDates(then);
                                })

                        } else {
                            if (servants[0])
                                setServant(servants[0].id);

                            if (then)
                                then();
                            $ctrl.updateAvailableDates(then);
                        }
                    }
                    , function () {
                        if (then)
                            then();
                        $ctrl.updateAvailableDates(then);

                    });

            }
        }

        function updateServantListWithDefault() {
            $ctrl.servantList = [];
            if ($ctrl.orderBagServiceItem.serviceItemId) {
                ServiceItemCustom.getServiceServants($ctrl.orderBagServiceItem.serviceItemId).query(function (servants) {
                    $ctrl.servantList = servants;
                    setServant($ctrl.defaultServantId);
                });
            }
        }

        function loadPage(page) {
            translatePartialLoader.addPart('orderBagServiceItemDtail');
            translatePartialLoader.addPart('orderBagServiceItem');
            translatePartialLoader.addPart('orderBagItemOption');
            translatePartialLoader.addPart('global');
            translatePartialLoader.addPart('participantPerson');
            translatePartialLoader.addPart('servant');
            translatePartialLoader = translate.refresh();

            initServiceItem();
            updateServiceList(setDefaultValues);

            if ($ctrl.initMode == 'DEFAULT')
                loadAllServiceItems();
            else if ($ctrl.initMode == 'CALENDAR_CUSTOM') {
                $ctrl.checkCapacity = false;
                loadServiceItemsByServantId();
                if ($ctrl.defaultServantId) {
                    $ctrl.servantList = [];
                    Servant.get({id: $ctrl.defaultServantId}).$promise.then(function (result) {
                        $ctrl.servantList.push(result);
                        setServant($ctrl.defaultServantId);
                    });

                }

                if ($ctrl.defaultStartDate)
                    makeDateList();
            }

        }

        function updateServiceList(then) {

            $ctrl.serviceItems = ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(onSuccess);

            function onSuccess() {
                if (then) {
                    then();
                }
                $ctrl.updateServantList(then);

            }
        }

        function setDefaultValues() {

            initDefaultSelectedItems();
            setDefaultServiceItem();
            setDefaultDateAndTime();
            setDefaultServant();
        }

        function initDefaultSelectedItems() {

            if ($ctrl.defaultSelectedService != null) {
                $ctrl.selectedService = $ctrl.defaultSelectedService;
                $ctrl.serviceItem_changed($ctrl.selectedService)
            }
            if ($ctrl.defaultSelectedServant != null) {
                $ctrl.selectedServant = $ctrl.defaultSelectedServant;
                $ctrl.servant_changed();
            }

        }

        function initServiceItem() {
            if ($ctrl.editMode == 'REPLACE_TIME')
                return;


            if (!$ctrl.orderBagServiceItem)
                $ctrl.orderBagServiceItem = {};
            $ctrl.orderBagServiceItem.servant = {};
            if (!$ctrl.orderBagServiceItem.index)
                $ctrl.orderBagServiceItem.index = 0;
        }

        function setDefaultServiceItem() {

            if ($ctrl.defaultServiceItemId != null && $ctrl.defaultServiceItemId != undefined) {
                $ctrl.orderBagServiceItem.serviceItemId = Number($ctrl.defaultServiceItemId);
                //$ctrl.serviceItem_changed();
                //setDefaultTimeSession();
                //setDefaultDateAndTime();
                //setDefaultServant();
                // loadAvailableDates();
            }
        }

        function setDefaultServant() {
            if ($ctrl.defaultServantId)
                setServant($ctrl.defaultServantId);

        }


        function setDefaultDateAndTime() {

            if ($ctrl.defaultStartDate != null && $ctrl.defaultStartDate != undefined &&
                $ctrl.defaultEndDate != null && $ctrl.defaultEndDate != "" && $ctrl.defaultEndDate != undefined) {
                $ctrl.selectedDynamicTime = new Date($ctrl.defaultStartDate).toISOString();
                $ctrl.selectedToTime = new Date($ctrl.defaultEndDate).toISOString();
                $ctrl.selectedDynamicDate = dateUtil.convertToISOString(new Date($ctrl.defaultStartDate));
                /*     updateAvailableDates(function(){
                 $ctrl.updateAvailableFromTime(function(){
                 $ctrl.selectedDynamicTime=new Date($ctrl.defaultStartDate).toISOString();
                 $ctrl.availableDynamicFromTime_changed();
                 $ctrl.selectedToTime=new Date($ctrl.defaultEndDate).toISOString();
                 $ctrl.availableDynamicToTime_changed();

                 });


                 });*/


                //loadAvailableTimes(function () {
                //
                //    availableTimes_changed();
                //});
            }
        }

        function getPriceInfoDtail() {

            if ($ctrl.orderBagServiceItem.serviceItemId == undefined || $ctrl.orderBagServiceItem.serviceItemId == null || $ctrl.orderBagServiceItem.serviceTimeSession == undefined || $ctrl.orderBagServiceItem.serviceTimeSession == null) {
                // error
                // have to evaluate
                return;
            }
            if ($ctrl.orderBagServiceItem != null && $ctrl.orderBagServiceItem != undefined && $ctrl.orderBagServiceItem.status != null && $ctrl.orderBagServiceItem.status == 1) {
                //do nothing
                // in view mode and not editable
            } else {
                var servantId = null
                if ($ctrl.orderBagServiceItem.servant && $ctrl.orderBagServiceItem.servant.id)
                    servantId = $ctrl.orderBagServiceItem.servant.id;
                PriceInfoDtailCustom.getPriceInfoDtailByServiceItemFromDate($ctrl.orderBagServiceItem.serviceItemId, servantId, $ctrl.orderBagServiceItem.serviceTimeSession.startTime).query(function (result) {

                    $ctrl.priceInfoDtails = result;
                    addOrderBagDtails();
                    // $ctrl.serviceItem_changed();
                    //reloadPrices();
                    changeControlsData()
                });

            }


        }

        function saveDtail() {
            $ctrl.isSaving = true;
            if ($ctrl.orderBagServiceItem.id !== null && $ctrl.orderBagServiceItem.id != undefined) {
                OrderBagServiceItem.update($ctrl.orderBagServiceItem, onSaveSuccess, onSaveError);
            } else {
                $ctrl.orderBagServiceItem.id = null;
                OrderBagServiceItem.save($ctrl.orderBagServiceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {


            $ctrl.isSaving = false;
            $ctrl.orderBagServiceItem = result;
            //reloadPrices();
            //findFormState();
            //  initParticipant();
            //$ctrl.formState ='participant';
        }

        function onSaveError() {
            $ctrl.isSaving = false;
        }

        function reloadPrices() {

            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined
                || $ctrl.orderBagServiceItem.length == 0 || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == null
                || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined
                || $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 0
            ) {
                return;
            }

            angular.forEach($ctrl.orderBagServiceItem.orderBagServiceItemDtail, function (v) {
                angular.forEach($ctrl.priceInfoDtails, function (p) {
                    if (v.priceInfoDtail.id == p.id) {
                        p.gty = v.gty;
                        if (v.options != null && v.options != undefined) {
                            p.options = [];
                            p.options = v.options;
                        }
                    }

                });

            });

        }

        function addOrderBagDtails() {

            clearOrderBagDetails();

            if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined) {
                $ctrl.orderBagServiceItem = {};
            }
            if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined) {
                $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
            }

            var x;
            for (var i = 0, len = $ctrl.priceInfoDtails.length; i < len; i++) {

                x = $ctrl.priceInfoDtails[i];
                if (x == null)
                    continue;

                //if priceInfoDetailID set in ReserveServiceItemDtail must Update Quantity
                //if (UpdateExistReserveServiceItemDtail(x, orderbagOptions))
                if (false) {
                    //do nothing
                } else {
                    var defaultQty = 0;
                    if (i == 0) defaultQty = 1;
                    $ctrl.orderBagServiceItem.orderBagServiceItemDtail.push({
                        gty: defaultQty,
                        price: x.price,
                        discount: x.discount,
                        vat: 0,
                        totalPrice: 0,
                        serviceTimeSession: $ctrl.orderBagServiceItem.serviceTimeSession,
                        //priceInfoDtailId: x.id,
                        priceInfoDtail: x,
                        orderBagItemOptions: null,
                        timeUnitQty: $ctrl.timeUnitQty
                    });
                }
            }

            //   computeTotalPrice();
            setShowCountBox();
        }

        function computeTotalPrice() {
            if ($ctrl.onItemChanged)
                $ctrl.onItemChanged($ctrl.orderBagServiceItem);
            // var orderBag = {};
            // orderBag.orderBagServiceItems = [];
            // orderBag.orderBagServiceItems.push($ctrl.orderBagServiceItem);
            // OrderBagCustom.computeFinalPrice().save(orderBag, function (result) {
            //
            //     if (result.orderBagServiceItems[0])
            //         $ctrl.orderBagServiceItem = result.orderBagServiceItems[0];
            // })

            //if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail == null || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined)
            //    return;
            //
            //var row;
            //var price = 0;
            //var discount = 0;
            //var vat = 0;
            //
            //var rowDiscount = 0;
            //var rowVat = 0;
            //var rowTotalPrice = 0;
            //
            //var subtotalService = 0;
            //var subtotalOptions = 0;
            //var subtotalDiscount = 0;
            //var subtotalVat = 0;
            //var finalPrice = 0;
            //var sumQty = 0;
            //
            //
            //if ($ctrl.settingInfo != null && $ctrl.settingInfo.financialSetting != null && $ctrl.settingInfo.financialSetting.taxPercentage != null) {
            //    vat = $ctrl.settingInfo.financialSetting.taxPercentage;
            //}
            //
            //
            //for (var i = 0, len = $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length; i < len; i++) {
            //
            //    row = $ctrl.orderBagServiceItem.orderBagServiceItemDtail[i];
            //    if (row.price != null)
            //        price = row.price;
            //    else
            //        price = 0
            //
            //    if (row.discount != null)
            //        discount = row.discount;
            //    else
            //        discount = 0
            //
            //    if (discount > 0) {
            //        rowDiscount = Math.round((discount * price / 100) * row.gty * $ctrl.timeUnitQty);
            //        row.totalPrice = (price * row.gty * $ctrl.timeUnitQty ) - rowDiscount;
            //    }
            //    else {
            //        rowDiscount = 0;
            //        row.totalPrice = price * row.gty * $ctrl.timeUnitQty;
            //    }
            //
            //    if (vat > 0) {
            //        rowVat = Math.round((row.totalPrice * vat) / 100);
            //        row.totalPrice = row.totalPrice + rowVat;
            //    }
            //
            //    sumQty += row.gty;
            //
            //    subtotalService = subtotalService + price * row.gty * $ctrl.timeUnitQty;
            //    subtotalDiscount = subtotalDiscount + rowDiscount;
            //    subtotalVat = subtotalVat + rowVat;
            //    rowTotalPrice = rowTotalPrice + row.totalPrice;
            //}
            //
            //$ctrl.orderBagServiceItem.subtotalOptionPrice = calculateOptionPrice(sumQty);
            //$ctrl.orderBagServiceItem.subtotalServicePrice = subtotalService;
            //$ctrl.orderBagServiceItem.subtotalVAT = subtotalVat;
            //$ctrl.orderBagServiceItem.subtotalDiscount = subtotalDiscount;
            //$ctrl.orderBagServiceItem.totalRowPrice = subtotalService + $ctrl.orderBagServiceItem.subtotalOptionPrice + subtotalVat - subtotalDiscount;

        }

        function calculateOptionPrice(qty) {

            var sumOfOptionPrice = 0;
            var row;
            if ($ctrl.orderBagServiceItem.options)
                for (var i = 0, len = $ctrl.orderBagServiceItem.options.length; i < len; i++) {

                    row = $ctrl.orderBagServiceItem.options[i];
                    if (row.selected) {
                        sumOfOptionPrice += row.priceInfoDtail.price * qty;
                    }
                }

            return sumOfOptionPrice;
        }


        function UpdateExistReserveServiceItemDtail(priceInfoDtail, options) {
            //
            //var hasChanged = false;
            //if ($ctrl.orderBagServiceItem == null || $ctrl.orderBagServiceItem == undefined
            //    || $ctrl.orderBagServiceItem.length == 0 || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == null
            //    || $ctrl.orderBagServiceItem.orderBagServiceItemDtail == undefined
            //    || $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 0
            //) {
            //    hasChanged = false;
            //}
            //
            //
            //angular.forEach($ctrl.orderBagServiceItem.orderBagServiceItemDtail, function (v) {
            //    if (v.priceInfoDtail.id == priceInfoDtail.id) {
            //        v.gty = priceInfoDtail.gty;
            //        v.orderBagItemOptions = options;
            //        hasChanged = true;
            //    }
            //
            //});
            //
            //
            //return hasChanged;
        }

        function prev() {
            $ctrl.formState = 'orderbagitem';
            //  reloadPrices();
        }


        function FinalApprove() {
            //saveDtail();
        }

        function serviceItem_changed(item) {

            $ctrl.selectedDate = null;
            $ctrl.selectedServiceTimeSession = {};


            if (item) {
                $ctrl.orderBagServiceItem.serviceItemId = item.id;
                if (item.duration)
                    $ctrl.selectedServiceDuration = item.duration;

                updateServantList();
            } else {
                $ctrl.orderBagServiceItem.serviceItemId = null;
                $ctrl.servantList = [];
            }


            $ctrl.onServiceChanged();

            if ($ctrl.initMode == 'CALENDAR_CUSTOM') {
                setDefaultToTime();
                availableDynamicToTime_changed();
            }
        }


        function openPersonInfoModal() {
            $uibModal.open({
                templateUrl: 'app/entities/participant-person/order-bag-item-participant-person-dialog.html',
                controller: 'OrderBagParticipantPersonDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            }).result.then(function (result) {
                addParticipantPerson(result);
            }, function () {
                //nothing
            });


        }


        function clearOrderBagDetails() {
            $ctrl.orderBagServiceItem.orderBagServiceItemDtail = null;
            $ctrl.orderBagServiceItem.orderBagServiceItemDtail = [];
        }

        function changeControlsData() {
            computeTotalPrice();

        }

        function qtyChanged() {

            changeControlsData();
        }

        function loadAvailableDates() {

            if ($ctrl.orderBagServiceItem.serviceItemId == undefined || $ctrl.orderBagServiceItem.serviceItemId == null) {
                // error
                // have to evaluate
                return;
            }
            $ctrl.orderBagServiceItem.serviceTimeSession = null;
            $ctrl.availableDates = [];
            var dates = ServiceTimeSessionCustom.getServiceTimeSessionFromNow($ctrl.orderBagServiceItem.serviceItemId).query(function (result) {
                angular.forEach(dates, function (d) {


                    if (d.capacity > 0) {

                        var similarDate = $ctrl.availableDates.filter(function (d2) {
                            if (d2.date == d.startDate)
                                return d2;
                        })
                        if (similarDate.length == 0) {
                            $ctrl.availableDates.push({date: d.startDate});
                        }
                    }

                });

            });


        }

        function servant_changed() {

            resetLoadDatesDefault();
            updateAvailableDates();

        }

        function availableDates_changed() {
            loadAvailableTimes();
        }

        function resetLoadDatesDefault() {
            $ctrl.availableDynamicDates = [];
            $ctrl.fromDateToLoad = new Date();
            $ctrl.toDateToLoad = DateUtils.addDays(new Date(), 30);
            $ctrl.loadedMore = false;
        }

        function loadAvailableTimes(then) {

            if ($ctrl.selectedDate == undefined || $ctrl.selectedDate == null)
                return;

            $ctrl.orderBagServiceItem.serviceTimeSession = null;

            var dateTime = new Date($ctrl.selectedDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            ServiceTimeSessionCustom.getAvailableServiceTimeSessionsInOneDate($ctrl.orderBagServiceItem.serviceItemId, dateTime.toISOString()).query(function (list) {
                $ctrl.availableTimes = list;
                if (then)
                    then();

            });

        }

        function availableTimes_changed() {
            //getPriceInfoDtail();
            //changeControlsData();
        }

        function uniqBy(a, key) {
            var seen = {};
            return a.filter(function (item) {
                var k = key(item);
                return seen.hasOwnProperty(k) ? false : (seen[k] = true);
            })
        }


        function updateAvailableDates(then) {

            if ($ctrl.isDatesLoading)
                return;

            $ctrl.isDatesLoading = true;
            ScheduleInfoCustom.getDynamicAvailableDatesByServiceIdAndServantId($ctrl.orderBagServiceItem.serviceItemId, getServantId(), $ctrl.fromDateToLoad, $ctrl.toDateToLoad).query(function (list) {
                var filteredList = [];
                var filteredDate = [];
                list.forEach(function (item) {
                    if (filteredDate.indexOf(item.spanDate) < 0) {
                        filteredList.push(item);
                        filteredDate.push(item.spanDate);
                    }
                });

                filteredList = filteredList.sort(function (a, b) {
                    // Turn your strings into dates, and then subtract them
                    // to get a value that is either negative, positive, or zero.
                    return new Date(a.spanDate) - new Date(b.spanDate);
                });

                if ($ctrl.availableDynamicDates && $ctrl.availableDynamicDates.length > 0) {
                    // add new dates to old list
                    filteredList.forEach(function (item) {
                        $ctrl.availableDynamicDates.push(item);
                    });

                } else {

                    $ctrl.availableDynamicDates = filteredList;
                    if (filteredList[0]) {
                        $ctrl.selectedDynamicDate = filteredList[0].spanDate;
                        setDefaultDateAndTime();
                    }
                }
                if (then)
                    then();
                $ctrl.updateAvailableFromTime(then);
                $ctrl.isDatesLoading = false;

                // in some cases dates not loaded completely
                // if(!$ctrl.loadedMore && $ctrl.availableDynamicDates && $ctrl.availableDynamicDates.length >=0 && $ctrl.availableDynamicDates.length <6)
                // {
                //     if(!$ctrl.isDatesLoading)
                //     {
                //         $ctrl.loadedMore = true ;
                //         $ctrl.fromDaysToLoad +=30 ;
                //         $ctrl.toDaysToLoad +=180 ;
                //         updateAvailableDates();
                //     }
                //
                // }
            });


        }

        function updateAvailableFromTime(then) {


            $ctrl.selectedDynamicTime = null;
            $ctrl.selectedToTime = null;
            if (!$ctrl.selectedDynamicDate) {
                $ctrl.availableDynamicTimes = [];
                $ctrl.selectedDynamicTime = null;
                $ctrl.updateAvailableToTime(then);
                return;
            }
            var dateTime = new Date($ctrl.selectedDynamicDate.toString());
            dateTime.setUTCHours(0, 0, 0);
            ScheduleInfoCustom.getDynamicAvailableTimesByServiceIdAndServantIdInOneDate($ctrl.orderBagServiceItem.serviceItemId, getServantId(), dateTime.toISOString()).query().$promise.then(function (result) {

                $ctrl.allAvailableDynamicTimes = result;
                $ctrl.availableDynamicTimes = result.filter(function (v) {
                        return (v.capacity > 0)
                    }
                );

                $ctrl.availableDynamicTimes = $ctrl.availableDynamicTimes.sort(function (a, b) {
                    return new Date(a.startTime) - new Date(b.startTime);
                });

                if ($ctrl.availableDynamicTimes && $ctrl.availableDynamicTimes.length > 0) {
                    $ctrl.selectedDynamicTime = $ctrl.availableDynamicTimes[0].startTime;
                    if (then)
                        then();
                    $ctrl.updateAvailableToTime(then);
                }
            });

        }

        function availableDynamicDates_changed() {

            updateAvailableFromTime();
        }

        function availableDynamicFromTime_changed() {


            updateAvailableToTime();
            setDefaultToTime();
        }

        function setMaxAvailableCapacity() {
            var capacity = 1000;
            if ($ctrl.selectedDynamicTime && $ctrl.selectedToTime) {
                if ($ctrl.availableDynamicTimes && $ctrl.availableDynamicTimes.length > 0) {
                    angular.forEach($ctrl.availableDynamicTimes, function (ts) {

                        if (ts.startTime >= $ctrl.selectedDynamicTime && ts.endTime <= $ctrl.selectedToTime) {
                            if (capacity > ts.capacity)
                                capacity = ts.capacity;
                        }

                    })
                } else {
                    capacity = 0;
                }
            }

            $ctrl.availableQty = [0];
            $ctrl.maxAvailableQty = capacity;
            if (capacity > 0) {

                var i = 0;
                while (i < capacity) {
                    i++;
                    $ctrl.availableQty.push(i);
                }
            }

        }

        function updateAvailableToTime(then) {

            if ($ctrl.initMode == 'CALENDAR_CUSTOM') {

                if ($ctrl.selectedDynamicDate) {
                    var dateTime = new Date($ctrl.selectedDynamicDate.toString());
                    makeToTimeList(dateTime);
                    return;
                }
            }


            if ($ctrl.selectedDynamicTime == undefined || $ctrl.selectedDynamicTime == null) {
                $ctrl.selectedToTime = null;
                $ctrl.toTimePeriodList = [];
                return;
            }
            $ctrl.selectedToTime = null;

            $ctrl.toTimePeriodList = [];

            var list = $ctrl.allAvailableDynamicTimes.filter(function (v) {
                    return (v.startTime >= $ctrl.selectedDynamicTime)
                }
            );


            var keepGoing = true;
            angular.forEach(list, function (time) {

                if (keepGoing) {
                    if (time.capacity == 0) {
                        keepGoing = false;
                    }
                    if (keepGoing == true)
                        $ctrl.toTimePeriodList.push(time);
                }
            })
            if ($ctrl.toTimePeriodList.length > 0)
                $ctrl.selectedToTime = new Date($ctrl.toTimePeriodList[0].endTime).toISOString();
            if (then)
                then();
            availableDynamicToTime_changed();

        }

        function availableDynamicToTime_changed() {
            //  computeTimeUnitQty();
            if ($ctrl.selectedDynamicTime != null && $ctrl.selectedToTime != null)
                $ctrl.orderBagServiceItem.serviceTimeSession = createTimeSession($ctrl.selectedDynamicTime, $ctrl.selectedToTime);
            setMaxAvailableCapacity();
            getPriceInfoDtail();

        }

        function computeTimeUnitQty() {

            var span = {
                startTime: $ctrl.selectedDynamicTime,
                endTime: $ctrl.selectedToTime,
                serviceItemId: $ctrl.orderBagServiceItem.serviceItemId
            }
            TimingInfo.computeTimeUnitQty().save(span, function (result) {
                $ctrl.timeUnitQty = result.timeUnitQty;
            })

            //;
            //if ($ctrl.toTimePeriodList == undefined || $ctrl.toTimePeriodList == null || $ctrl.toTimePeriodList.length == 0) {
            //    $ctrl.timeUnitQty = 1;
            //    return;
            //}
            //if ($ctrl.selectedToTime == undefined || $ctrl.selectedToTime == null) {
            //    $ctrl.timeUnitQty = 0;
            //    return;
            //}
            //
            //
            //var keepGoing = true;
            //var timeUnitCount = 0;
            //var capacity = 100;
            //angular.forEach($ctrl.toTimePeriodList, function (toTime) {
            //    ;
            //    if (keepGoing) {
            //
            //            if(toTime.capacity!=null && toTime.capacity < capacity)
            //                capacity = toTime.capacity;
            //            if (toTime.endTime == $ctrl.selectedToTime) {
            //                keepGoing = false;
            //            }
            //
            //            timeUnitCount++;
            //
            //        }
            //    }
            //);
            //
            //if (timeUnitCount > 0)
            //    $ctrl.timeUnitQty = timeUnitCount;
            //
            //$ctrl.dynamicCapacity = capacity;

        }

        function createTimeSession(fromTime, toTime) {
            var newTimeSession = {};

            var fromDate = new Date(fromTime.toString());
            var toDate = new Date(toTime.toString());


            newTimeSession.startTime = fromTime;
            newTimeSession.endTime = toTime;
            newTimeSession.startDate = fromDate;
            newTimeSession.endDate = toDate;
            newTimeSession.capacity = $ctrl.dynamicCapacity;

            return newTimeSession;


        }

        function showPrices() {

            if ($ctrl.scheduleType != 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.orderBagServiceItem.serviceTimeSession != undefined && $ctrl.orderBagServiceItem.serviceTimeSession.id != undefined)
                    return true;
            }
            if ($ctrl.scheduleType == 'FLOAT_TIME_SESSIONS') {
                if ($ctrl.floatingTimeType == 'HOURLY') {
                    if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.selectedDynamicTime != null && $ctrl.selectedToTime != null)
                        return true;
                }
                if ($ctrl.floatingTimeType == 'MONTHLY') {
                    if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.selectedDynamicMonthlyDate != null && $ctrl.timeUnitQty != null)
                        return true;
                }
            }
        }


        function timeUnitQty_Changed() {

            computeTotalPrice();
        }

        function setShowCountBox() {

            $ctrl.showCountBox = true;
            if ($ctrl.orderBagServiceItem == null)
                return;

            var selectedServiceItem = findSelectedServiceItem();


            if ($ctrl.orderBagServiceItem.orderBagServiceItemDtail != null && $ctrl.orderBagServiceItem.orderBagServiceItemDtail.length == 1) {
                if (
                    ($ctrl.maxAvailableQty == 1
                        && (selectedServiceItem.servant == null || selectedServiceItem.servant == undefined
                            || (selectedServiceItem.servant != null
                                && (selectedServiceItem.servant.capacity == null || selectedServiceItem.servant.capacity == undefined
                                    || (selectedServiceItem.servant.capacity != null && selectedServiceItem.servant.capacity == 1)))))
                    ||
                    ($ctrl.maxAvailableQty > 1
                        && selectedServiceItem.servant != null && selectedServiceItem.servant != undefined
                        && (selectedServiceItem.servant.capacity == null || selectedServiceItem.servant.capacity == undefined
                            || (selectedServiceItem.servant.capacity != null && selectedServiceItem.servant.capacity == 1)))
                ) {
                    $ctrl.showCountBox = false;
                }
            }


        }

        function findSelectedServiceItem() {

            if ($ctrl.orderBagServiceItem.serviceItemId != null && $ctrl.orderBagServiceItem.serviceItemId != undefined) {
                var temp = $ctrl.serviceItems.filter(function (si) {
                    if (si.id == $ctrl.orderBagServiceItem.serviceItemId)
                        return si;
                })
                $ctrl.selectedService = temp[0];
            }

            var selectedServiceItem = null;

            if ($ctrl.orderBagServiceItem.serviceItemId != null) {
                selectedServiceItem = $ctrl.serviceItems.filter(function (si) {
                    if (si.id == $ctrl.orderBagServiceItem.serviceItemId)
                        return si;
                })

            }
            return selectedServiceItem;
        }

        function makeDateList() {
            var date = new Date($ctrl.defaultStartDate);
            var dates = [];

            var timeSpan = makeTimeSpanObject(date);
            for (var i = 9; i > 0; i--) {
                var before = {};
                before = new Date(Number(date));
                ;
                before.setDate(date.getDate() - i);

                var beforeTimeSpan = makeTimeSpanObject(before);
                dates.push(beforeTimeSpan);
            }

            dates.push(timeSpan);

            for (var i = 1; i < 10; i++) {
                var after = {};
                after = new Date(Number(date));
                ;
                after.setDate(date.getDate() + i);

                var afterTimeSpan = makeTimeSpanObject(after);
                dates.push(afterTimeSpan);
            }


            $ctrl.availableDynamicDates = dates;
            $ctrl.selectedDynamicDate = timeSpan.spanDate;

            makeTimeList(date);

        }

        function makeTimeSpanObject(date, hour, minute) {
            var timeSpan = {};
            var startTime, endTime = new Date();
            startTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
            if (hour != null)
                startTime.setHours(hour);
            if (minute != null)
                startTime.setMinutes(minute);

            timeSpan.spanDate = date.toISOString().split('T')[0];
            timeSpan.startTime = startTime.toISOString();
            timeSpan.endTime = startTime.toISOString();
            if ($ctrl.selectedService && $ctrl.selectedService.capacity)
                timeSpan.capacity = $ctrl.selectedService.capacity;
            else
                timeSpan.capacity = 1;
            timeSpan.comment = "";
            timeSpan.discount = 0;
            timeSpan.edited = false;
            timeSpan.enable = true;
            timeSpan.id = null;
            timeSpan.price = 0;
            timeSpan.reservedCapacity = null;
            timeSpan.servantId = null;
            timeSpan.serviceItemId = null;
            timeSpan.sessionInfoId = null;
            timeSpan.timeSessionType = null;
            timeSpan.timeUnitQty = 0;

            return timeSpan;
        }

        function makeTimeList(date) {

            var selectedFromTime = makeTimeSpanObject(date);
            var startTimes = getSelectableTimes(date, false);
            $ctrl.availableDynamicTimes = startTimes;
            $ctrl.selectedDynamicTime = selectedFromTime.startTime;
            availableDynamicFromTime_changed();

        }

        function makeToTimeList(date) {

            // if($ctrl.selectedServiceDuration)
            //     date = new Date(date.getTime() + $ctrl.selectedServiceDuration*60000);
            $ctrl.toTimePeriodList = [];
            var startTimes = getSelectableTimes(date, true);
            $ctrl.toTimePeriodList = startTimes;
            availableDynamicToTime_changed();
        }

        function getSelectableTimes(date, mustFilter) {
            var startMinute = 0;
            var startHour = 0;
            var stepper = 5;
            var selectableTimes = [];
            for (var h = startHour; h < 24; h++) {
                for (var m = startMinute; m < 60; m = m + stepper) {
                    var time = {};
                    time = makeTimeSpanObject(date, h, m);
                    if (mustFilter) {
                        if (!isInRange(time)) {
                            continue;
                        }

                    }
                    selectableTimes.push(time);
                }

            }
            return selectableTimes;

        }

        function isInRange(timeSpan) {

            var isInRange = true;
            if ($ctrl.selectedDynamicTime) {
                var min = new Date($ctrl.selectedDynamicTime);
                var temp = new Date(timeSpan.startTime);
                if (temp.getHours() > min.getHours()) {

                } else if (temp.getHours() == min.getHours()) {
                    if (temp.getMinutes() <= min.getMinutes()) {
                        isInRange = false;
                    }
                } else {

                    isInRange = false;
                }
            }
            return isInRange;

        }

        function setDefaultToTime() {

            if ($ctrl.selectedServiceDuration) {

                var x = $ctrl.selectedDynamicTime;
                var date = new Date($ctrl.selectedDynamicTime);
                date.setMinutes(date.getMinutes() + $ctrl.selectedServiceDuration);
                $ctrl.selectedToTime = date.toISOString();
            }
        }

        function loadMoreAvailableDates() {
            if (!$ctrl.isDatesLoading) {
                if ($ctrl.availableDynamicDates && $ctrl.availableDynamicDates.length > 0) {
                    $ctrl.fromDateToLoad = new Date($ctrl.availableDynamicDates[$ctrl.availableDynamicDates.length - 1].spanDate);
                    $ctrl.fromDateToLoad = DateUtils.addDays($ctrl.fromDateToLoad, 1);
                    $ctrl.toDateToLoad = DateUtils.addDays($ctrl.toDateToLoad, 30);
                    updateAvailableDates();
                }

            }
        }

        // $scope.$watch('$ctrl.availableDynamicDates',function(){
        //     if($ctrl.availableDynamicDates && $ctrl.availableDynamicDates.length > 0 && $ctrl.availableDynamicDates.length < 6)
        //     {
        //
        //         loadMoreAvailableDates();
        //     }
        // });


    }


    var ReserveServiceItem = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/orderbag-service-item/partial-form.reserve-service-item.html',
        controller: ReserveServiceItemController,
        bindings: {
            //serviceItemId: '<',
            //selectedServiceTimeSession: '=',
            orderBagServiceItem: '=',
            defaultServiceItemId: '=',
            defaultServiceTimeSessionId: '=',
            defaultStartDate: '=',
            defaultEndDate: '=',
            defaultServantId: '=',
            hasMultipleReserveTime: '=',
            indexOfOrderbag: '=',
            initMode: '=',
            onItemChanged: '&',
            onServiceChanged: '&',
            checkCapacity: '=',
            defaultSelectedService: '=',
            defaultSelectedServant: '=',
            editMode: '='


            //formState:'=',

        }


    };

    angular
        .module('tikonApp')
        .component('pfReserveServiceItem', ReserveServiceItem)

    ReserveServiceItemController.$inject = ['$uibModal', '$scope', '$state', '$stateParams', 'PriceInfoCustom', 'PriceInfoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ServiceOptionItem', 'ServiceOptionItemCustom', 'PriceInfoDtailCustom', 'OrderBagServiceItem', 'ServiceItemCustom', 'ServiceTimeSessionCustom', 'SettingInfoCustom', 'ServiceTimeSession', 'DateUtils', 'ScheduleInfoCustom', 'TimingInfo', 'OrderBagCustom', 'Servant', 'DateUtils'];


})();

